/**
 * DRMAccountsCtrl controller
 * Show all drm accounts and profiles
 */

import { DRM_ACCOUNT_TYPES_LABELS, DRM_PROFILE_TYPES } from 'app/core/constants'

// controller mixins
DRMAccountsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * DRMAccountsCtrl controller
 *
 * @class DRMAccountsCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:DRMAccountsCtrl
 */
/* @ngInject */
export default function DRMAccountsCtrl ($scope, $location, DRMAccount, DRMProfile) {
  var vm = this

  vm.isFound = true

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * DRM Account types
   *
   * @memberof mwApp/settings.controller:DRMAccountsCtrl
   * @type {{}}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES_LABELS

  /**
   * DRM Profile drm types
   *
   * @memberof mwApp/settings.controller:AddDRMAccountCtrl
   * @type {{}}
   */
  vm.drm_profle_types = DRM_PROFILE_TYPES

  /**
   * DRM Accounts list
   *
   * @memberof mwApp/settings.controller:DRMAccountsCtrl
   * @type {models.DRMAccount[]}
   */
  vm.accounts = []

  /**
   * Get DRM Accounts from backend
   *
   * @memberof mwApp/settings.controller:DRMAccountsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getDRMAccounts = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    DRMAccount.loadSmart(tableState)
      .then(data => {
        vm.accounts = data.content
        vm.isFound = !!vm.accounts.length

        $scope.loading = false
      })
  }

  /**
   * Delete Account
   *
   * @memberof mwApp/settings.controller:DRMAccountsCtrl
   * @param {models.DRMAccount} account
   */
  vm.delete = function (account) {
    account._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }

  /**
   * Get DRM Profiles by account
   *
   * @memberof mwApp/settings.controller:DRMAccountsCtrl
   */
  vm.getDRMProfiles = (account) => (tableState) => {
    if (!account.__open) {
      return
    }

    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    const promise = DRMProfile.loadSmart(tableState, { drmAccountId: account.id })
      .then(data => data.content.map((c) => {
        c.drmAccountId = account.id
        return c
      }))

    // init profiles
    if (!account.$profiles.length) {
      promise.to(account.$profiles)
    } else {
      promise.then(content => account.$profiles = content)
    }
  }
}
